<template>
  <div>
    <v-card class="d-flex justify-center mb-1 mt-1">
      <v-card flat class="pa-2">
        <v-select
          :label="$t('message.limit_usage.period')"
          :items="periods"
          item-text="label"
          item-value="value"
          v-model="period"
          hide-details
          @input="render_graph()"
        >
          <template v-slot:item="props">
            {{ $t('message.limit_usage.period_' + props.item.label) }}
          </template>
          <template v-slot:selection="props">
            <v-list-item class="pa-2 pl-0" style="min-height:auto">
              {{ $t('message.limit_usage.period_' + props.item.label) }}
            </v-list-item>
          </template>
        </v-select>
      </v-card>
      <v-card flat class="pa-2">
        <v-select
          :label="$t('message.limit_usage.resource')"
          :items="resources"
          item-text="label"
          item-value="value"
          v-model="resource"
          hide-details
          @input="get_resource_data()"
        >
          <template v-slot:item="props">
            {{ $t('message.limit_usage.resource_' + props.item.label) }}
          </template>
          <template v-slot:selection="props">
            <v-list-item class="pa-2 pl-0" style="min-height:auto">
              {{ $t('message.limit_usage.resource_' + props.item.label) }}
            </v-list-item>
          </template>
        </v-select>
      </v-card>
      <v-card flat class="pa-2">
        <v-select
          :label="$t('message.limit_usage.display')"
          :items="displays"
          item-text="label"
          item-value="value"
          v-model="display"
          hide-details
          @input="render_graph()"
        >
          <template v-slot:item="props">
            {{ $t('message.limit_usage.display_' + props.item.label) }}
          </template>
          <template v-slot:selection="props">
            <v-list-item class="pa-2 pl-0" style="min-height:auto">
              {{ $t('message.limit_usage.display_' + props.item.label) }}
            </v-list-item>
          </template>
        </v-select>
      </v-card>
    </v-card>
    <template v-if="display == 'table'">
      <v-data-table
        :headers="headers"
        :items="data[period]"
        :sort-by="['utime']"
        :sort-desc="[true]"
        must-sort
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 100]
        }"
      >
        <template v-slot:item.utime="{ item }">
          {{ $d(new Date(1000 * item.utime), period, $store.getters.langs[$i18n.locale].locale) }}
        </template>
        <template v-slot:item.cur="{ item }">
          {{ change_value(item.cur) | comma_digit }}
        </template>
        <template v-slot:item.max="{ item }">
          <template v-if="item.max">
            {{ change_value(item.max) | comma_digit }}
          </template>
          <template v-else>
            -
          </template>
        </template>
      </v-data-table>
    </template>
    <template v-else-if="display == 'graph'">
      <!-- bad knowhow https://github.com/apertureless/vue-chartjs/issues/503#issuecomment-531597173 -->
      <Chart
        :chartData="chartData"
        :chartOptions="chartOptions"
        :height="null"
        :width="null"
      ></Chart>
    </template>
    <v-overlay
      :absolute="true"
      :value="progress_overlay"
    >
      <v-progress-circular
        :value="progress"
      >
        {{ progress }}
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Chart from '../components/Chart';
import { http_error } from "../js/http_error";
import colors from 'vuetify/lib/util/colors'

export default {
  name: 'usage',
  mixins: [http_error],
  components: {
    Chart
  },
  props: {
    path: String  // "/"起点とする
  },
  data: function(){
    return {
      module_id: "81",
      period: "hour",
      resource: "",
      display: "table",
      search_resource: "",
      data: {
        year: [],
        month: [],
        day: [],
        hour: [],
        f_min: []
      },
      graph_data: {
        year: {
          label : [],
          cur : [],
          max : []
        },
        month: {
          label : [],
          cur : [],
          max : []
        },
        day: {
          label : [],
          cur : [],
          max : []
        },
        hour: {
          label : {},
          cur : [],
          max : []
        },
        f_min: {
          label : {},
          cur : [],
          max : []
        }
      },
      periods: [
        {
          "label": "year",
          "value": "year"
        },
        {
          "label": "month",
          "value": "month"
        },
        {
          "label": "day",
          "value": "day"
        },
        {
          "label": "hour",
          "value": "hour"
        },
        {
          "label": "f_min",
          "value": "f_min"
        }
      ],
      resources: [],
      displays: [
        {
          "label": "table",
          "value": "table"
        },
        {
          "label": "graph",
          "value": "graph"
        }
      ],
      chartData: null,
      chartOptions: {},
      progress: 0,
      progress_overlay: false,
      unit: ''
    }
  },
  mounted: function(){
    this.get_resource_index();
  },
  methods: {
    get_resource_index: function() {
      this.progress_overlay = true;
      this.progress = 0;
      this.$http.get(this.$store.getters.api_endpoint + this.path + "/resource",
                     {
                       onDownloadProgress: function( progressEvent ) {
                         this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                       }.bind(this)
                     })
        .then( response => {
          this.progress = 100;
          this.progress_overlay = false;
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          var resoures = [];
          for(var resource of response.data.upper){
            if(resource in response.data.current && !response.data.current[resource]){
              continue;
            }
            resoures.push({
              label: resource,
              value: resource
            });
          }
          this.resources = resoures;
          if(this.resource === ""){
            this.resource = this.resources[0].value;
          }
          this.get_resource_data();
        })
        .catch( error => {
          this.progress_overlay = false;
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    get_resource_data: function() {
      this.progress_overlay = true;
      this.progress = 0;
      this.$http.get(this.$store.getters.api_endpoint + this.path + "/" + this.resource,
                     {
                       onDownloadProgress: function( progressEvent ) {
                         this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                       }.bind(this)
                     })
        .then( response => {
          this.progress = 100;
          this.progress_overlay = false;
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          // period別のutimeをキーとする連想配列を作成する。古いデータも混じっている
          var resource_data = {
            year: {},
            month: {},
            day: {},
            hour: {},
            f_min: {}
          };
          for(var key in response.data){
            var value = response.data[key];
            switch(key[0]){
              case "y":
                resource_data.year[value.utime] = value;
                break;
              case "m":
                resource_data.month[value.utime] = value;
                break;
              case "d":
                resource_data.day[value.utime] = value;
                break;
              case "h":
                resource_data.hour[value.utime] = value;
                break;
              case "f":
                resource_data.f_min[value.utime] = value;
                break;
            }
          }
          this.make_date(resource_data);
          this.change_unit();
        })
        .catch( error => {
          this.progress_overlay = false;
          if(this.http_error(error)){
            if(error.response.status === 404){
              this.make_date({
                year: {},
                month: {},
                day: {},
                hour: {},
                f_min: {}
              });
            }else{
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
          }
        });
    },
    make_date: function(resource_data){
      // 現在時刻から対象期間までのデータを作成する。存在しないデータは0とする
      var data = {
        year: [],
        month: [],
        day: [],
        hour: [],
        f_min: []
      };
      var graph_data = {
        year: {
          label : [],
          cur : [],
          max : [],
        },
        month: {
          label : [],
          cur : [],
          max : [],
        },
        day: {
          label : [],
          cur : [],
          max : [],
        },
        hour: {
          label : [],
          cur : [],
          max : [],
        },
        f_min: {
          label : [],
          cur : [],
          max : [],
        }
      };

      var now = new Date();
      // year: 5年分
      var year = now.getUTCFullYear();
      for(var y = year - 4; y <= year; y++){
        var t = new Date(Date.UTC(y, 0, 1, 0, 0, 0)).getTime() / 1000;
        if(t in resource_data.year){
          data.year.push(resource_data.year[t]);
          graph_data.year.label.push(t);
          graph_data.year.cur.push(this.change_value(resource_data.year[t].cur));
          graph_data.year.max.push(this.change_value(resource_data.year[t].max));
        }else{
          data.year.push({
            cur: 0,
            max: 0,
            utime: t
          });
          graph_data.year.label.push(t);
          graph_data.year.cur.push(0);
          graph_data.year.max.push(0);
        }
      }
      // month: 12ヶ月分
      var month = now.getUTCMonth();
      for(var m = month + 1; m < 12; m++){
        var t = new Date(Date.UTC(year - 1, m, 1, 0, 0, 0)).getTime() / 1000;
        if(t in resource_data.month){
          data.month.push(resource_data.month[t]);
          graph_data.month.label.push(t);
          graph_data.month.cur.push(this.change_value(resource_data.month[t].cur));
          graph_data.month.max.push(this.change_value(resource_data.month[t].max));
        }else{
          data.month.push({
            cur: 0,
            max: 0,
            utime: t
          })
          graph_data.month.label.push(t);
          graph_data.month.cur.push(0);
          graph_data.month.max.push(0);
        }
      }
      for(var m = 0; m <= month; m++){
        var t = new Date(Date.UTC(year, m, 1, 0, 0, 0)).getTime() / 1000;
        if(t in resource_data.month){
          data.month.push(resource_data.month[t]);
          graph_data.month.label.push(t);
          graph_data.month.cur.push(this.change_value(resource_data.month[t].cur));
          graph_data.month.max.push(this.change_value(resource_data.month[t].max));
        }else{
          data.month.push({
            cur: 0,
            max: 0,
            utime: t
          })
          graph_data.month.label.push(t);
          graph_data.month.cur.push(0);
          graph_data.month.max.push(0);
        }
      }
      // day: 30日分
      var day = now.getUTCDate();
      var t = new Date(Date.UTC(year, month, day, 0, 0, 0)).getTime() / 1000;
      for(var d = t - 29 * 86400; d <= t; d += 86400){
        if(d in resource_data.day){
          data.day.push(resource_data.day[d]);
          graph_data.day.label.push(d);
          graph_data.day.cur.push(this.change_value(resource_data.day[d].cur));
          graph_data.day.max.push(this.change_value(resource_data.day[d].max));
        }else{
          data.day.push({
            cur: 0,
            max: 0,
            utime: d
          })
          graph_data.day.label.push(d);
          graph_data.day.cur.push(0);
          graph_data.day.max.push(0);
        }
      }
      // hour: 24時間分
      var hour = now.getUTCHours();
      var t = new Date(Date.UTC(year, month, day, hour, 0, 0)).getTime() / 1000;
      for(var h = t - 23 * 3600; h <= t; h += 3600){
        if(h in resource_data.hour){
          data.hour.push(resource_data.hour[h]);
          graph_data.hour.label.push(h);
          graph_data.hour.cur.push(this.change_value(resource_data.hour[h].cur));
          graph_data.hour.max.push(this.change_value(resource_data.hour[h].max));
        }else{
          data.hour.push({
            cur: 0,
            max: 0,
            utime: h
          })
          graph_data.hour.label.push(h);
          graph_data.hour.cur.push(0);
          graph_data.hour.max.push(0);
        }
      }
      // 5min: 1時間分
      var t = Math.floor(now.getTime() / 1000 / 300) * 300;
      for(var m = t - 11 * 300; m <= t; m += 300){
        if(m in resource_data.f_min){
          data.f_min.push(resource_data.f_min[m]);
          graph_data.f_min.label.push(m);
          graph_data.f_min.cur.push(this.change_value(resource_data.f_min[m].cur));
          graph_data.f_min.max.push(this.change_value(resource_data.f_min[m].max));
        }else{
          data.f_min.push({
            cur: 0,
            max: 0,
            utime: m
          })
          graph_data.f_min.label.push(m);
          graph_data.f_min.cur.push(0);
          graph_data.f_min.max.push(0);
        }
      }
      this.data = data;
      this.graph_data = graph_data;
      this.render_graph();
    },
    render_graph: function(){
      var new_label = [];
      for(var l of this.graph_data[this.period].label){
        new_label.push(this.$i18n.d(1000 * l, this.period, this.$store.getters.langs[this.$i18n.locale].locale));
      }
      this.chartData = {
        labels: new_label,
        datasets: [
          {
            type: "line",
            label: this.$i18n.t("message.limit_usage.max"),
            data: this.graph_data[this.period].max,
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: colors.grey.darken1,
            pointRadius: 0
          },
          {
            type: "bar",
            label: this.$i18n.t("message.limit_usage.cur"),
            data: this.graph_data[this.period].cur,
            backgroundColor: colors.grey.lighten1,
          }
        ]
      };
      this.chartOptions = {
        responsive: true,
        aspectRatio: 2,
        scales: {
          xAxes: [{
            scaleLabel: {
              display: false,
              labelString: this.$i18n.t("message.limit_usage.period_" + this.period)
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function(label, index, labels) {
                if (Math.floor(label) === label) {
                  return label;
                }
              }
            }
          }]
        }
      };
    },
    change_unit() {
      if(this.resource === 'file_size') {
        this.unit = '(KB)';
      }
      else if(this.resource === 'model_size') {
        this.unit = '(MB)';
      }
      else {
        this.unit = '';
      }
    },
    change_value(value) {
      if(this.resource === 'file_size') {
        return (value / 1024).toFixed(1);
      }
      else if(this.resource === 'model_size') {
        return (value / 1024 / 1024).toFixed(1);
      }
      else {
        return value;
      }
    }
  },
  computed: {
    headers: function() {
      return [
        { text: this.$i18n.t("message.limit_usage.date"), value: 'utime' },
        { text: `${this.$i18n.t("message.limit_usage.cur")}${this.unit}`, value: 'cur', align: 'right' },
        { text: `${this.$i18n.t("message.limit_usage.max")}${this.unit}`, value: 'max', align: 'right' }
      ];
    },
    locale: function(){
      return this.$i18n.locale;
    }
  },
  watch: {
    locale: function(val){
      this.render_graph();
    }
  }
}
</script>
